import { SET_PREV_SETTING } from "constants/ActionTypes";

export default (state, action) => {
  switch (action.type) {
    case SET_PREV_SETTING:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
